export default __webpack_public_path__ + "static/media/High Kick.3eb810fa.png";